export const enAuthTranslations = {
  auth: {
    login: {
      ssoFailed: {
        title: 'Single Sign-On failed.',
        body: 'Please try again. If the problem persists, contact support.',
      },
      loginRefused: {
        title: "We couldn't sign you in.",
        body: 'Please try again. If the problem persists, contact support.',
      },
      ssoRequired:
        'Your organization requires Single Sign-On. Enter your company email to continue.',
    },
  },
};
